var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toHome",on:{"click":_vm.toHome}})
}
var staticRenderFns = []

export { render, staticRenderFns }